import React from "react";
import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { Card, Button } from "antd";
import "./styles/notifications.css";
import PDF from "../assets/pdfs/T1 SLA.pdf";
import { useNavigate } from "react-router-dom";
import { DownloadOutlined, BackwardOutlined } from "@ant-design/icons";
const ServiceAgreement = () => {
  const history = useNavigate();
  const namingData = useSelector((state) => state.user);
  //console.log(namingData);
  return (
    <div>
      {" "}
      <div className="main-body">
        <header>
          <NavBar data={namingData.data} />
        </header>
        <div className="main-container">
          <div className="first-pp">
            <div style={{ width: "75%", margin: "0 auto" }}>
              <Card
                // size="small"
                hoverable
                bodyStyle={{
                  padding: "2rem",
                  paddingTop: "0",
                  paddingBottom: "1rem",
                }}
                style={{
                  width: "auto",
                  paddingBottom: 10,
                  marginTop: 20,
                  borderRadius: 15,
                }}
              >
                <>
                  <div
                    className="myapps"
                    style={{
                      textAlign: "center",
                      fontSize: "1.9rem",
                      fontWeight: "600",
                    }}
                  >
                    SERVICE LEVEL AGREEMENT{" "}
                  </div>
                  <div className="privacy-container-2">
                    <p>Last updated: May 1, 2023</p>
                    <br />
                    <p>
                      Trainery 1 SLA – During the term of the applicable
                      Trainery 1 subscription service agreement (the
                      "Agreement"), Trainery will use commercially reasonable
                      efforts to make the Covered Service operational and
                      available to Customer at least 99% of the time in any
                      calendar month (the "Trainery SLA"). If Trainery does not
                      meet the Trainery 1 SLA in a given calendar month, and if
                      Customer complies with and meets its obligations under
                      this Service Level Agreement and the Agreement, Customer
                      will be eligible to receive the Service Credits described
                      below. This Trainery 1 SLA states Customer's sole and
                      exclusive remedy for any failure by Trainery Software to
                      meet the Trainery 1 SLA.
                    </p>
                    <br />
                    <h3>Definitions</h3>
                    <p>
                      The following definitions shall apply to the Trainery 1
                      SLA:
                    </p>
                    <ul>
                      <li>
                        "Covered Service" or "Service" means Trainery 1. This
                        does not include any other related Trainery Software
                        services like Trainery API.
                      </li>
                      <li>
                        "Downtime" means, subject to the exclusions set forth in
                        this Service Level Agreement, any period of time during
                        which Customer is unable to access the Covered Service
                        due to server-side errors or reachability errors
                        attributable to Trainery Software, as determined by
                        Trainery Software's system logs and other records.
                      </li>
                      <li>
                        "Monthly Uptime Percentage" means the total number of
                        minutes in a calendar month minus the number of minutes
                        of Downtime suffered in a calendar month, divided by the
                        total number of minutes in a calendar month.
                      </li>
                      <li>"Service Credit" means the following:</li>
                    </ul>
                    <br />
                    <table>
                      <tr>
                        <th>Monthly Uptime Percentage</th>
                        <th>
                          Days of Service added to the end of the Service term
                          at no charge to Customer
                        </th>
                      </tr>
                      <tr>
                        <td>{`>`}= 95.0% to &lt; 99.0%</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>&lt; 95.0%</td>
                        <td>7</td>
                      </tr>
                    </table>
                    <br />
                    <h3>Customer Must Request Service Credit</h3>
                    <p>
                      In order to receive any of the Service Credits described
                      above, Customer must notify Trainery Software in writing
                      within ten (10) days from the time Customer becomes
                      eligible to receive a Service Credit. Failure to comply
                      with this requirement will forfeit the Customer's right to
                      receive a Service Credit.
                    </p>
                    <br />
                    <h3>Maximum Service Credit</h3>
                    <p>
                      The aggregate maximum number of Service Credits to be
                      issued by Trainery Software to Customer for all Downtime
                      that occurs in a single calendar month shall not exceed
                      fifteen (15) days of Service added to the end of
                      Customer's term for the Service (or the value of fifteen
                      (15) days of Service in the form of a monetary credit to
                      be issued to Customer's account for monthly-billing
                      customers only). Service Credits will not be issued as
                      refunds and cannot be exchanged for, or converted to,
                      monetary amounts, except for customers who are on Trainery
                      monthly billing plan.
                    </p>
                    <br />
                    <h3>Scheduled and Unscheduled Maintenance</h3>
                    <p>
                      Any "Scheduled Maintenance" time does not count toward the
                      calculation of Downtime. Scheduled Maintenance is
                      classified as any maintenance on the Covered Service that
                      is communicated to Customer at least two (2) full business
                      days in advance. Scheduled Maintenance may take
                      approximately eight (8) hours per calendar month and is
                      typically performed during non-business hours in the USA.
                      Trainery hereby provides notice to Customer, and Customer
                      acknowledges and agrees, that Scheduled Maintenance will
                      be performed every Thursday from 10:00 PM to 11:00 PM US
                      EST and Sunday 10:00 PM to 12:00 AM US EST.
                    </p>
                    <p>
                      Trainery will attempt to notify Customer in advance of
                      performing "Unscheduled Maintenance"; provided, however,
                      that Customer acknowledges that Unscheduled Maintenance
                      may be performed without prior notice. Unscheduled
                      Maintenance will be counted as Downtime for the purpose of
                      the Trainery SLA if it meets the definition of Downtime in
                      all other respects.
                    </p>
                    <br />
                    <h3>Trainery 1 SLA Exclusions</h3>
                    <p>
                      The Trainery 1 SLA does not apply to any Downtime or other
                      performance issues:
                    </p>
                    <ol>
                      <li>
                        caused by a Force Majeure event or other factors outside
                        of Trainery's reasonable control;
                      </li>
                      <li>
                        resulting from any act or omission of Customer,
                        including, but not limited to, Customer's negligence,
                        breach of the Agreement, or failure to use the Covered
                        Service in compliance with the applicable documentation;
                        or
                      </li>
                      <li>
                        that result from Customer's equipment or any third-party
                        equipment, or both (not within the primary control of
                        Trainery Software).
                      </li>
                    </ol>
                    <br />
                    <h3>Updates/Notice</h3>
                    <p>
                      The current version of this Service Level Agreement may be
                      found online when logged into the application. This
                      Service Level Agreement may be amended by Trainery from
                      time to time in its discretion upon thirty (30) days'
                      advance notice to Customer. Such notice may be provided to
                      a user designated as an administrator on Customer's
                      account either:
                    </p>
                    <ol type="a">
                      <li>
                        as a note on the screen presented immediately after
                        completion of the login authentication credentials at
                        the login screen, or
                      </li>
                      <li>
                        by email to the registered email address provided for
                        the administrator(s) for Customer's account.
                      </li>
                    </ol>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      height: "2rem",
                      paddingTop: "1rem",
                    }}
                  >
                    <Button
                      key="back"
                      style={{ marginRight: "1rem", fontSize: "1.5rem" }}
                      onClick={() => {
                        history("/home");
                      }}
                    >
                      <BackwardOutlined /> Back
                    </Button>

                    <Button
                      type="primary"
                      href={PDF}
                      style={{ fontSize: "1.5rem" }}
                      rel="noopener noreferrer"
                      download="T1 SLA.pdf"
                    >
                      <DownloadOutlined />
                      PDF
                    </Button>
                  </div>
                </>
              </Card>
            </div>
          </div>
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default ServiceAgreement;
